/**
 * @generated SignedSource<<12bfc1a20c0410977d9cf4eefbba979d>>
 * @relayHash fdba35e5f0062e767c15f71d1f4a0f5b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 54b2d24d9c98e52c7ce70d0802c352895b1b0a62e3e0330f1c88c256d284b983

import type { ConcreteRequest } from 'relay-runtime';
export type EditPageAgentSessionNudgesQuery$variables = {
  aqlQuery: string;
  first: number;
  shardingContext: string;
};
export type EditPageAgentSessionNudgesQuery$data = {
  readonly agent_sessionAssociationQuery: {
    readonly nodes: ReadonlyArray<{
      readonly agentSession: {
        readonly agent: {
          readonly picture: AGG$URL;
        } | null;
        readonly conversationChannel: {
          readonly id: string | null;
          readonly name: string | null;
          readonly readStatus: boolean | null;
        } | null;
        readonly id: string | null;
      } | null;
    } | null> | null;
  } | null;
};
export type EditPageAgentSessionNudgesQuery = {
  response: EditPageAgentSessionNudgesQuery$data;
  variables: EditPageAgentSessionNudgesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "aqlQuery"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shardingContext"
},
v3 = [
  {
    "kind": "Variable",
    "name": "aqlQuery",
    "variableName": "aqlQuery"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "shardingContext",
    "variableName": "shardingContext"
  },
  {
    "kind": "Literal",
    "name": "sort",
    "value": "lastStateChangeAt DESC"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "picture"
},
v6 = {
  "args": [
    {
      "kind": "Variable",
      "name": "workspaceAri",
      "variableName": "shardingContext"
    }
  ],
  "concreteType": "AgentConversationChannel",
  "kind": "LinkedField",
  "name": "conversationChannel",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "ScalarField",
      "name": "readStatus"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "EditPageAgentSessionNudgesQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "AgentSessionAssociationConnection",
        "kind": "LinkedField",
        "name": "agent_sessionAssociationQuery",
        "plural": false,
        "selections": [
          {
            "concreteType": "AgentSessionAssociation",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "concreteType": "AgentSession",
                "kind": "LinkedField",
                "name": "agentSession",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "agent",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ]
                  },
                  (v6/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "EditPageAgentSessionNudgesQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "AgentSessionAssociationConnection",
        "kind": "LinkedField",
        "name": "agent_sessionAssociationQuery",
        "plural": false,
        "selections": [
          {
            "concreteType": "AgentSessionAssociation",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "concreteType": "AgentSession",
                "kind": "LinkedField",
                "name": "agentSession",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "agent",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v5/*: any*/),
                      (v4/*: any*/)
                    ]
                  },
                  (v6/*: any*/)
                ]
              },
              (v4/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "fdba35e5f0062e767c15f71d1f4a0f5b",
    "id": "54b2d24d9c98e52c7ce70d0802c352895b1b0a62e3e0330f1c88c256d284b983",
    "metadata": {},
    "name": "EditPageAgentSessionNudgesQuery",
    "operationKind": "query",
    "text": "query EditPageAgentSessionNudgesQuery($aqlQuery:String!,$shardingContext:String!,$first:Int!){agent_sessionAssociationQuery(aqlQuery:$aqlQuery,shardingContext:$shardingContext,first:$first,sort:\"lastStateChangeAt DESC\"){nodes{agentSession{id,agent{__typename,picture,id},conversationChannel(workspaceAri:$shardingContext)@optIn(to:[\"AgentConversationChannelTeamEu26DemoOnly\"]){id,name,readStatus}},id}}}"
  }
};
})();

(node as any).hash = "7ee883ac8d33158a354f664d5675fc44";

export default node;
